var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "rbCheckboxOptionButton",
      class: { readonly: _vm.readonly, selected: _vm.isSelected },
      attrs: { type: "button" },
      on: {
        click: function ($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.onClick.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "span",
        {
          staticClass: "material-icons rbCheckboxOptionIcon",
          attrs: { "aria-hidden": "true" },
        },
        [_vm._v(_vm._s(_vm.stateIcon))]
      ),
      _vm.checkBoxLabel
        ? _c("span", { staticClass: "rbCheckboxOptionText" }, [
            _vm._v(_vm._s(_vm.checkBoxLabel)),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }